import React, { useState } from "react";
import {
  Box,
  PageTitle,
  Text,
  Grid,
  Button,
  Loader,
  Tabs,
  Spacer,
} from "@flexisaf/flexibull2";
import BreadCrumbs from "../../components/breadcrumb";
import { DetailsCard } from "../exam-group";
import Questions from "./support/questions";
import Theme from "../../theme";
import useSinglePaperGet from "../../hooks/papers/useSinglePaperGet";
import { useParams } from "react-router-dom";
import PaperEditor from "./modals/paperEditor";
import Section from "./support/section";

const Paper = () => {
  const [modal, setModal] = useState({
    show: false,
    data: null,
  });
  const [activeTab] = useState(0);
  const [reloadTabs] = useState(false);
  const onEdit = (data) => {
    setModal({
      show: true,
      data,
    });
  };

  const { id } = useParams();
  const { paper } = useSinglePaperGet({ id });

  return (
    <Box>
      <PageTitle>
        <i className="saf-clipboard-text" />
        <Text bold size={Theme.H3} style={{ padding: "0 10px" }}>
          Paper
        </Text>
      </PageTitle>
      <BreadCrumbs
        links={[
          {
            path: `/exam-groups/${paper?.exam?.examGroup?.id}`,
            text: "Exams",
          },
          {
            path: `/exams/${paper?.exam?.id}`,
            text: paper?.exam?.name,
          },
        ]}
        last={paper?.name || "Paper name"}
      />
      <Box>
        <Grid default="2fr 2fr 1fr">
          <DetailsCard>
            {" "}
            <Box>
              <Text size="1.2rem" color={Theme.PrimaryColor} bold>
                {paper?.name}
              </Text>
              <Spacer space="10px" />
              <Text size="1.rem" color={Theme.PrimaryGrey} block>
                {paper?.exam?.name}, {paper?.exam?.examGroup?.name}
              </Text>
            </Box>
          </DetailsCard>
          <Box />
          <Box>
            <Button
              style={{ width: "fit-content", marginLeft: "auto" }}
              pale
              block
              onClick={() => onEdit(paper)}
            >
              Edit Paper Information
            </Button>
          </Box>
        </Grid>
      </Box>
      <Box pad="1rem 0">
        {reloadTabs ? (
          <Box pad="150px 0">
            <Loader color={Theme.PrimaryColor} section />
          </Box>
        ) : (
          <Tabs
            activeTab={activeTab}
            padContent="35px 0 0 0"
            bgColor={Theme.PrimaryFade}
          >
            <Box label="Questions">
              <Questions paperId={paper?.id} paper={paper} />
            </Box>
            <Box label="Sections">
              <Section paperId={paper?.id} />
            </Box>
          </Tabs>
        )}
      </Box>
      {modal?.show && (
        <PaperEditor
          open={modal.show}
          data={modal.data}
          cbProps={{ refetchPaper: true }}
          closeModal={() => {
            setModal({
              show: false,
              data: null,
            });
            document.body.style.overflow = "auto";
          }}
        />
      )}
    </Box>
  );
};

export default Paper;
